import React, { FC } from 'react'

import { IconTalkProps } from './IconTalk.types'
import * as Styled from './styles/IconTalk.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTalk: FC<IconTalkProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTalkProps['size'],
  isResponsive = false,
}: IconTalkProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M5.125 40.928c1.59-9.698 7.277-15.615 14.332-15.615 7.055 0 12.75 5.925 14.333 15.615'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M19.457 7.072h9.12v9.12a9.12 9.12 0 1 1-9.12-9.12v0Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M33.525 18.183a5.563 5.563 0 0 1 0 7.867m3.267-11.135a10.185 10.185 0 0 1 0 14.402'
          stroke='#E60000'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M39.693 12.015a14.285 14.285 0 0 1 0 20.2' stroke='#E60000' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconTalk
